import { Link, useNavigate } from "react-router-dom"
import Pagination from "../../Components/Pagination"
import { MyContext } from "../../Components/Context";
import { useContext } from "react";
import SearchField from "../../Components/Forms/SearchField";


export default function LastCus({data}){


    const navigate = useNavigate();
    const {actifItem, setActifItem} = useContext(MyContext);
    
    



    return (
        <div className="">
            <p className="text-xl font-bold text-gray-800 dark:text-gray-200 sm:text-2xl">Les client Recent</p>
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm">
                <table className="w-full text-sm text-left table-auto">
                    <thead className="font-medium text-gray-600 bg-gray-200 border-b border-gray-600 dark:text-gray-200 dark:bg-gray-800">
                        <tr>
                            <th className="px-6 py-3">Id</th>
                            <th className="px-6 py-3">Nom</th>
                            <th className="px-6 py-3">Prenom</th>
                            <th className="px-6 py-3">Date de creation</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left transition bg-gray-200 border-gray-600 rounded cursor-pointer hover:bg-gray-200 duration-900 dark:text-gray-200 hover:text-gray-800 dark:bg-gray-800"
                                        onClick={()=>{
                                            navigate(`/client/details/${item.id}`)
                                            setActifItem('Annonces')
                                        }}
                                    >
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <img src={`${process.env.REACT_APP_API_PICTURE_URL}${item.picture}`} alt={'annonceAnnonce'} className="w-10 h-10 rounded-full" />
                                                <div>
                                                    <span className="block text-sm font-medium ">{item.id}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.lastname}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.firstname}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}